import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cardStepOne: 'We ask for some information about you and your business',
    cardStepThree: 'Your account is open!',
    cardStepTwo: 'We verify your identity',
    cardTitle: 'Create your micro-entreprise with Shine',
    ctaLabel: 'Let’s go!',
    howItWorks: 'View steps',
    title: 'My micro-entreprise',
  },
  fr: {
    cardStepOne:
      'Nous recueillons vos informations d’identité et celles de votre future entreprise',
    cardStepThree: 'Votre compte est ouvert\u00A0!',
    cardStepTwo: 'Nous vérifions votre identité',
    cardTitle: 'Créez votre micro-entreprise avec Shine',
    ctaLabel: 'C’est parti\u00A0!',
    howItWorks: 'Voir les étapes',
    title: 'Ma micro-entreprise',
  },
} as const);
